import { render, staticRenderFns } from "./SubHeader.vue?vue&type=template&id=7d261410&scoped=true"
var script = {}
import style0 from "./SubHeader.vue?vue&type=style&index=0&id=7d261410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d261410",
  null
  
)

export default component.exports